export enum ExpedienteEstados {
  ingresado = 1,
  aprobado = 2,
  rechazado = 3,
  solicitud_prorroga = 4,
  prorroga_aprobada = 5,
  prorroga_rechazada = 6,
  cerrado = 7,
  enviado_fiscalizacion = 8,
  resolucion_firmada = 9,
  resolucion_apelada = 10,
  apelacion_rechazada = 11,
  apelacion_aprobada = 12,
  apelacion_suseso = 13,
  // RFC4: estado asignado al expediente al ser devuelto por el Presidente al fiscalizador
  en_correccion = 14
}

export default ExpedienteEstados;